export const DATABASE_CACHE_SERVICE_I18N = {
  jobTitle: {
    unspecified: $localize`:@@data.cache.jobTitle.unspecified:職種未指定`,
  },
  userType: {
    staff: $localize`:@@data.cache.userType.staff:スタッフ`,
    supervisor: $localize`:@@data.cache.userType.supervisor:Supervisor`,
    contributor: $localize`:@@data.cache.userType.contributor:多職種スタッフ`,
  },
} as const;
